<div #reviewField *ngIf="visible">
    <cv-schema-render-form-display
        [fieldOptions]="options"
        [field]="field"
        [value]="value"
        [historical]="historical"
        [show]="show"
        [active]="active">
    </cv-schema-render-form-display>

    <ng-container *ngFor="let option of optionList">
        <ng-container *ngIf="!isEditing">
            <cv-schema-render-form-display
                [fieldOptions]="option.fieldOptions"
                [field]="option.field"
                [value]="option.value"
                [historical]="option.historical"
                [show]="option.show">
            </cv-schema-render-form-display>
        </ng-container>
    
        <ng-container *ngIf="isEditing">
            <cv-schema-render-form-input
                [fieldOptions]="option.fieldOptions"
                [control]="option.formControl"
                [field]="option.field"
                [value]="option.value"
                [historical]="option.historical"
                [show]="option.show"
                [indexTab]="indexTab">
            </cv-schema-render-form-input>
        </ng-container>
    </ng-container>
</div>